import React, { useMemo } from "react";
import { Table } from "ui";
import { handleTransactions } from "../utils";
import { transaction } from "../type";
import { TRANSACTIONS_TABLE_COLUMNS } from "./constant";

interface TransactionsTableProp {
  transactions?: transaction[];
  error?: string | null;
  isLoading?: boolean;
  page: number;
  pageSize: number;
}
export const TransactionsTable: React.FC<TransactionsTableProp> = ({
  transactions,
  error,
  isLoading,
  page,
  pageSize,
}) => {
  const data = useMemo(() => {
    return (
      handleTransactions(transactions)?.map((item, i) => {
        const head = item.latest;
        const subRows = item.data.map((subItem, index) => {
          return {
            $: `${i + 1 + pageSize * (page - 1)} - ${index + 1}`,
            reference_number: subItem.referenceNumber || "-",
            tracking_number: subItem.trackingNumber || "-",
            buy_Id: subItem.buyID || "-",
            amount: Number(subItem.amount).toLocaleString() || "-",
            date: subItem.date || "-",
            time: subItem.time || "-",
            status: subItem.statusText || "-",
            card_number: subItem.cardNumber || "-",
          };
        });
        return {
          $: i + 1 + pageSize * (page - 1),
          reference_number: head.referenceNumber || "-",
          tracking_number: head.trackingNumber || "-",
          buy_Id: head.buyID || "-",
          amount: Number(head.amount).toLocaleString() || "-",
          date: head.date || "-",
          time: head.time || "-",
          status: head.statusText || "-",
          card_number: head.cardNumber || "-",
          subRows: subRows.length ? subRows : null,
        };
      }) || []
    );
  }, [page, pageSize, transactions]);
 
  if (!!error) {
    return <div className="w-100 flex-center text-danger">{error}</div>;
  } else {
    return (
      <Table
        isLoading={isLoading}
        columns={TRANSACTIONS_TABLE_COLUMNS}
        tableClass="w-100"
        containerClass="w-100"
        data={data}
        getRowCanExpand={() => true}
      />
    );
  }
};
